'use strict';

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _constants = require('../../utils/constants');

var _constants2 = _interopRequireDefault(_constants);

var _applicationState = require('../../utils/applicationState');

var _networkUrlBuilder = require('../../utils/networkUrlBuilder');

var _networkUrlBuilder2 = _interopRequireDefault(_networkUrlBuilder);

var _imaPlayerAdapter = require('../../ads/media/players/ima/imaPlayerAdapter');

var _imaPlayerAdapter2 = _interopRequireDefault(_imaPlayerAdapter);

var _reporter = require('../../ads/reporter');

var _reporter2 = _interopRequireDefault(_reporter);

var _htmlUtils = require('../../utils/htmlUtils');

var _htmlUtils2 = _interopRequireDefault(_htmlUtils);

var _prerollUtils = require('../../utils/prerollUtils');

var _prerollUtils2 = _interopRequireDefault(_prerollUtils);

var _logger = require('../../logging/logger');

var _logger2 = _interopRequireDefault(_logger);

var _constants3 = require('../constants');

var _mediaEvents = require('../media/mediaEvents');

var _mediaEvents2 = _interopRequireDefault(_mediaEvents);

var _Events = require('../media/Events');

var _Events2 = _interopRequireDefault(_Events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var PREROLL_SLOT_ID = 'preroll';
var ADSWIZZ_SYNCHROBOX_SCRIPT_ID = 'ADSWIZZ_SYNCHROBOX_SCRIPT';
var ADSWIZZ_SYNCHROCLIENT_SCRIPT_ID = 'ADSWIZZ_SYNCHROCLIENT_SCRIPT';

var prerollAdController = {
  isImaPlayer: false,
  player: null,
  slot: null,
  init: function init() {
    this.initScripts();
    this.player = _imaPlayerAdapter2.default;
    this.player.init();
  },
  initScripts: function initScripts() {
    // add adswizz tracking scripts
    var _getState = (0, _applicationState.getState)(_applicationState.State.gdprData),
        isOptedOutOfGdpr = _getState.isOptedOut,
        gdprApplies = _getState.gdprApplies,
        tcString = _getState.tcString;

    var _getState2 = (0, _applicationState.getState)(_applicationState.State.ccpaStatus, {}),
        ccpaStatus = _getState2.value;

    var queryParams = ['us_privacy=' + ccpaStatus];

    if (gdprApplies) {
      var isOneTrustEnabled = (0, _get2.default)((0, _applicationState.getState)(_applicationState.State.options), 'ads.onetrust.gdpr.consent.form.enabled');

      if (isOneTrustEnabled) {
        queryParams.push(_constants3.ADSWIZZ_GDPR_TCFV2_TCSTRING_PARAMETER + '=' + tcString);
      } else {
        queryParams.push(_constants3.ADSWIZZ_GDPR_CONSENT_PARAMETER + '=' + !isOptedOutOfGdpr);
      }
    }

    var serializedQueryParams = queryParams.join('&');

    _htmlUtils2.default.addScript(_constants3.ADSWIZZ_SYNCHROBOX_SCRIPT + '?' + serializedQueryParams, false, ADSWIZZ_SYNCHROBOX_SCRIPT_ID);
    _htmlUtils2.default.addScript(_constants3.ADSWIZZ_SYNCHROCLIENT_SCRIPT + '?' + serializedQueryParams, false, ADSWIZZ_SYNCHROCLIENT_SCRIPT_ID);
  },
  registerSlot: function registerSlot(slot) {
    var _this = this;

    if ((0, _get2.default)(slot, 'name') !== PREROLL_SLOT_ID) {
      return;
    }
    this.slot = slot;

    (0, _applicationState.addStateChangeListener)(_applicationState.State.isPrerollPlayerMinimized, function () {
      if ((0, _applicationState.getState)(_applicationState.State.isPrerollPlayerMinimized) === true) {
        _reporter2.default.minimize(_this.slot);
      } else {
        _reporter2.default.maximize(_this.slot);
      }
    });
  },
  deregisterSlot: function deregisterSlot(slot) {
    this.player.deregisterSlot(slot);
    this.slot = null;
  },
  isRegistered: function isRegistered(slot) {
    return this.slot === slot;
  },
  canServePreroll: function canServePreroll() {
    var canServePreroll = !_prerollUtils2.default.prerollDisabled() && !_prerollUtils2.default.prerollAlreadyPlayed();

    if (!canServePreroll) {
      _logger2.default.debug('Preroll is disabled.');
    }

    return canServePreroll;
  },

  serveAd: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
      var _this2 = this;

      var partnerId, options, _getState3, ccpaStatus, videoEnabled, urlTag;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!this.slot || !this.isRegistered(params.slot) || !this.canServePreroll())) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', Promise.resolve());

            case 2:
              if (this.player.isInitialized()) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return this.player.initializeAndRegisterSlot(this.slot);

            case 5:
              partnerId = (0, _applicationState.getState)(_applicationState.State.partnerId);
              options = (0, _applicationState.getState)(_applicationState.State.options);
              _getState3 = (0, _applicationState.getState)(_applicationState.State.ccpaStatus, {}), ccpaStatus = _getState3.value;
              videoEnabled = (0, _applicationState.getState)(_applicationState.State.isScreenBigEnoughForVideoAds) && (0, _get2.default)((0, _applicationState.getState)(_applicationState.State.nowPlaying), 'ads.canShowVideoPrerollAds') && (0, _get2.default)((0, _applicationState.getState)(_applicationState.State.options), 'ads.videoPreroll.enabled', 'true') === 'true';

              // TUNE-11772, https://support.google.com/admanager/answer/2880055

              if ((0, _get2.default)(global.google, 'ima.settings.setPpid')) {
                global.google.ima.settings.setPpid((0, _applicationState.getState)(_applicationState.State.ppid));
              }

              urlTag = void 0;

              if (params.slot.formatDefinition.adProvider === _constants2.default.Networks.dfp && this.slot) {
                urlTag = _networkUrlBuilder2.default.buildDfpUrl({
                  adUnitId: (0, _get2.default)(this.slot, 'formatDefinition.adUnitId'),
                  videoEnabled: !!videoEnabled
                }, ccpaStatus);
              } else {
                urlTag = _networkUrlBuilder2.default.buildAdswizzUrl(partnerId, options, ccpaStatus);
              }

              return _context.abrupt('return', new Promise(function (resolve, reject) {
                var playerParams = (0, _assign2.default)(params, {
                  urlTag: urlTag
                });
                _mediaEvents2.default.event(_Events2.default.Type.preroll, _Events2.default.Status.loading).emit();
                _this2.player.serveAd(playerParams).then(function () {
                  resolve();
                }).catch(function (err) {
                  reject(err);
                });
              }));

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function serveAd(_x) {
      return _ref.apply(this, arguments);
    }

    return serveAd;
  }(),
  releaseSlot: function releaseSlot() {
    return undefined;
  },
  preload: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (this.slot) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return');

            case 2:
              _context2.next = 4;
              return this.player.preload(this.slot);

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function preload() {
      return _ref2.apply(this, arguments);
    }

    return preload;
  }(),
  play: function play(position) {
    this.player.play(position);
  },
  pause: function pause() {
    this.player.pause();
  },
  stop: function stop() {
    this.player.stop();
  },
  volume: function volume(_volume) {
    this.player.volume(_volume);
  },
  resize: function resize(width, height) {
    this.player.resize(width, height);
  }
};
module.exports = prerollAdController;